// endpoints.ts
// List of generic fetch functions
import { fetchBackend as fetch } from "@/core/apis/backend"
import { EntityWithId } from "@/core/factory/types"

export function createEntityEndpoints(entityName: string) {
  return {
    fetch: async (route?: string) => {
      const url = route ? `/${entityName}s/${route}` : `/${entityName}s`
      return await fetch({ url })
    },
    fetchOne: async (id: string) => await fetch({ url: `/${entityName}`, data: { id } }),
    create: async (data: EntityWithId) => await fetch({ url: `/${entityName}`, method: "POST", data }),
    update: async (data: EntityWithId) => await fetch({ url: `/${entityName}/${data.id}`, method: "PUT", data }),
    remove: async (id: string) => await fetch({ url: `/${entityName}/${id}`, method: "DELETE" })
  }
}
